import React, { useCallback, useContext } from "react";

//MUI
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

//Custom
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";

//Types
import { IDataController } from "@/@types/lib/dataController";
import { SnackbarContextType } from "@/@types/ui/SnackbarContext";

export type DeleteIconButtonProps = {
  disabled?: boolean;
  recordId: number,
  dc: IDataController
  onDeleted?:() => void;
}

function DeleteIconButton(props: DeleteIconButtonProps) {

  const snackbarContext = useContext(SnackbarContext) as SnackbarContextType

  const { recordId, dc, onDeleted, disabled = false } = props;

  const handleClick = useCallback((evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    console.log("DELETE")
    dc.DeleteRecord(recordId).then((resp) => {
      if (resp.success) {
        if (onDeleted) {
          onDeleted();
        }
      } else {
        if (snackbarContext !== null) {
          //@ts-ignore
          snackbarContext.showNotification(resp.error, "error");
        }
      }
    })
    .catch((resp) => {
      if (snackbarContext !== null) {
        //@ts-ignore
        snackbarContext.showNotification(resp.error.message, "error");
      }
    })
  }, [recordId, dc.apiPath])

  return (
    <IconButton color="primary" size="small" 
      disabled={disabled}
      onClick={(evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        handleClick(evt);
      }}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  )
}

export default DeleteIconButton;
